import { call, put, select, takeEvery } from "redux-saga/effects";
import { AuthActionTypes, GetHubspotAuthURLRequestActionType } from "../../auth/types";
import { getHubspotAuthURLFailure, getHubspotAuthURLSuccess } from "../../auth/actionCreators";
import { FormsService } from "../../../services/forms";

function* handleGetHubspotAuthURL() {
    try {
        const formId: string = yield select(state => state.forms.current._id);

        const response: { data: { data: string } } = yield call(FormsService.getHubspotAuthURL, formId);

        yield put(
            getHubspotAuthURLSuccess({
                success: true,
                message: "",
                data: response.data.data,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Hubspot authentication URL";
        yield put(getHubspotAuthURLFailure(errorMessage));
    }
}

export function* watchGetHubspotAuthURL() {
    yield takeEvery<GetHubspotAuthURLRequestActionType>(
        AuthActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST,
        handleGetHubspotAuthURL,
    );
}
